<mat-nav-list>
  @for (item of filteredMenuItems(); track item.id) {
  @if (item.children?.length) {
  <mat-list-item (click)="toggle(item.id)">
    <mat-icon [class.rotated]="expandedItems().includes(item.id)" matListItemIcon>keyboard_arrow_right</mat-icon>
    <span matListItemTitle>{{ item.label }}</span>
  </mat-list-item>
  @if (expandedItems().includes(item.id)) {
  <div>
    <mat-nav-list [class.open]="expandedItems().includes(item.id)" class="nested-list">
      @for (child of item.children; track child.id) {
      <mat-list-item [routerLink]="child.route" routerLinkActive="active-link">
        <span matListItemIcon class="material-symbols-outlined">{{ child.icon }}</span>
        <span matListItemTitle>{{ child.label }}</span>
      </mat-list-item>
      }
    </mat-nav-list>
  </div>
  }
  } @else {
  @if (item.id.startsWith('divider')) {
  <mat-divider class="n-menu-divider"></mat-divider>
  } @else {
  <mat-list-item [routerLink]="item.route" routerLinkActive="active-link">
    <span matListItemIcon class="material-symbols-outlined" matListItemIcon>{{ item.icon }}</span>
    <span matListItemTitle>{{ item.label }}</span>
  </mat-list-item>
  }
  }
  }
  <mat-divider class="n-menu-divider"></mat-divider>
</mat-nav-list>
@if (authService.isAdmin) {
<mat-checkbox (change)="updateViewAsRegular($event.checked)">View as regular user</mat-checkbox>
}